// ═══════════════════════════════════════════════════════════════════
//  modules/documents/FileMetaForm.js
//  FileMetaForm
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { Field } from "../../composants/Field";
import { btnGhost, btnPrimary, inp, modalBox, modalOverlay } from "../../composants/styles";
import { API_BASE, authHeaders } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { DOC_FILE_CATEGORIES, DOC_FILE_CAT_LABELS } from "./constantes";

export function FileMetaForm({ token, file, onClose, onSaved }) {
  const [f,setF]=useState({ categorie:file.categorie||"divers", tags:file.tags||"", resume:file.resume||"", statut:file.statut||"actif" });
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>setF((p)=>({...p,[k]:v}));
  const save=async()=>{ setSaving(true); try{ const r=await fetch(`${API_BASE}/api/documents/files/${file.id}`,{method:"PUT",headers:authHeaders(token),body:JSON.stringify({...f,ia_status:"manuel"})}); if(!r.ok)throw new Error(); onSaved(); }catch{ alert("Enregistrement impossible (étape 4)."); } setSaving(false); };
  return (
    <div style={modalOverlay} onClick={onClose}>
      <div style={modalBox} onClick={(e)=>e.stopPropagation()}>
        <div style={{color:THEME.text,fontSize:16,fontWeight:800,marginBottom:4}}>Classement du fichier</div>
        <div style={{color:THEME.textMuted,fontSize:12,marginBottom:16,wordBreak:"break-all"}}>{file.nom_origine}</div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
          <Field label="Catégorie"><select value={f.categorie} onChange={(e)=>set("categorie",e.target.value)} style={inp}>{DOC_FILE_CATEGORIES.map((c)=><option key={c} value={c}>{DOC_FILE_CAT_LABELS[c]}</option>)}</select></Field>
          <Field label="Statut"><select value={f.statut} onChange={(e)=>set("statut",e.target.value)} style={inp}><option value="actif">Actif</option><option value="archive">Archivé</option><option value="corbeille">Corbeille</option></select></Field>
          <Field label="Tags (séparés par virgule)" full><input value={f.tags} onChange={(e)=>set("tags",e.target.value)} style={inp} /></Field>
          <Field label="Résumé" full><textarea value={f.resume} onChange={(e)=>set("resume",e.target.value)} style={{...inp,minHeight:70,resize:"vertical"}} /></Field>
        </div>
        <div style={{display:"flex",gap:10,justifyContent:"flex-end",marginTop:18}}>
          <button onClick={onClose} style={btnGhost}>Annuler</button>
          <button onClick={save} disabled={saving} style={{...btnPrimary,opacity:saving?0.6:1}}>{saving?"…":"Enregistrer"}</button>
        </div>
      </div>
    </div>
  );
}
